import { render, staticRenderFns } from "./WsAlert.vue?vue&type=template&id=795c9ed4&"
import script from "./WsAlert.vue?vue&type=script&lang=js&"
export * from "./WsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports